<script>
    import { onDestroy, onMount } from "svelte";

    export let alternatives;
    export let content;

    let expanding = false;
    let collapsing = false;
    let interval;

    onMount(function() {
        interval = setInterval(function() {
            let nextText = alternatives[Math.floor(Math.random()*alternatives.length)];
            collapsing = true;
            setTimeout(function() {
                content = nextText;
                collapsing = false;
                expanding = true;
                setTimeout(function() {
                    expanding = false;
                }, 500);
            }, 500);
        }, 4000);
    });

    onDestroy(function() {
        clearInterval(interval);
    });

</script>

<style>

    .replace {
        overflow-x: hidden;
        white-space: nowrap;
        display: inline-block;
    }

    :global(.collapsing) {
        animation: collapsing 500ms linear 0s;
    }

    @keyframes collapsing {
        from { width: 100%; }
        to { width: 0%; }
    }

    :global(.expanding) {
        animation: expand 500ms linear 0s;
    }

    @keyframes expand {
        from { width: 0%; }
        to { width: 100%; }
    }

</style>

<span class="replace" class:expanding class:collapsing>{content}</span>